import {atom} from "recoil";


export const order = atom({
    key: "order",
    default: null,
});

export const customerOrder = atom({
    key: "customerOrder",
    default: null,
});
export const orderProducts = atom({
    key: "orderProducts",
    default: [],
});
